export default theme => ({
  productName: {
    marginTop: theme.spacing(1),
  },
  productDesc: {
    paddingLeft: theme.spacing(2),
  },
  unitPrice: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontSize: 16,
  },
  inputIndex: {
    fontSize: 14,
    color: theme.palette.text.grey700,
  },
  addCustomButton: {
    color: theme.palette.success.main,
    borderColor: theme.palette.success.main,
  },
  deleteButton: {
    color: theme.palette.danger.main,
    borderColor: theme.palette.danger.main,
  },
  groupStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  groupBadgeStyles: {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
  },
});
